module.exports = __webpack_public_path__ + "static/media/iot.ed2196ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/iot.png
// module id = 1541
// module chunks = 0